import React from 'react';
import { motion } from 'framer-motion';
import cn from 'classnames';
import { breakpoints, colors } from '../../config';

const Option = ({
  id,
  image,
  title,
  name,
  subtitle,
  variant = '', // text, details, image, icon
  details,
  active = false,
  register,
  value,
  defaultChecked,
  ...rest
}) => (
  <div>
    <input
      id={id}
      type="radio"
      name={name}
      ref={register}
      value={value}
      defaultChecked={defaultChecked}
    />

    <label htmlFor={id} className={cn('option', { active: active })} {...rest}>
      <span className="option-circle"></span>

      {image && (variant === 'icon' || variant === 'image') && (
        <motion.img
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="option-image"
          src={image}
        />
      )}

      {variant !== 'details' ? (
        <div style={{ flex: 1 }}>
          {title && <div className="option-title">{title}</div>}
          {subtitle && <div className="option-subtitle">{subtitle}</div>}
        </div>
      ) : (
        <div style={{ flex: 1 }}>
          <div className="option-details-title">{title}</div>
          <div className="option-details-subtitle">{subtitle}</div>
          <div className="option-details-content">{details}</div>
        </div>
      )}
    </label>

    <style jsx>{`
      .option {
        align-items: center;
        background-color: ${colors.white};
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(6, 21, 33, 0.05), 0 0 3px 0 rgba(16, 25, 32, 0.05);
        border: 2px solid transparent;
        cursor: pointer;
        display: flex;
        justify-content: ${variant === 'text' ? 'center' : 'flex-start'};
        margin-bottom: 16px;
        padding: ${variant === 'image' ? 16 : 24}px 24px;
        position: relative;
        transition: border-color 0.35s ease;
      }

      input {
        opacity: 0;
        position: absolute;
      }

      input:focus + .option {
        outline: ${colors.outline};
      }

      input:checked ~ label,
      .option.active {
        border-color: ${colors.orange};
      }

      .option-circle {
        border-radius: 50%;
        border: 2px solid #dcdcdc;
        width: 16px;
        height: 16px;
        margin-right: 16px;
        transition: border-color 0.35s ease;
        position: relative;
        display: flex;
        align-self: ${variant === 'details' ? 'flex-start' : 'unset'};
        margin-top: ${variant === 'details' ? '7px' : 0};
      }

      @media screen and (max-width: ${breakpoints.md}) {
        .option-circle {
          margin-right: 12px;
        }
      }

      .option-circle:before {
        content: '';
        margin: auto;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        transform: scale(0);
        background-color: ${colors.orange};
        transition: transform 0.35s ease;
      }

      input:checked ~ label > .option-circle,
      .option.active .option-circle {
        border-color: ${colors.orange};
      }

      input:checked ~ label > .option-circle:before,
      .option.active .option-circle:before {
        transform: scale(1);
      }

      .option :global(.option-image) {
        margin-right: 16px;
        max-width: 90px;
      }

      @media screen and (max-width: ${breakpoints.md}) {
        .option :global(.option-image) {
          margin-right: 12px;
        }
      }

      .option-title {
        font-size: ${variant === 'image' ? '16px' : '18px'};
        font-weight: ${variant !== 'details' ? 'bold' : 'normal'};
        line-height: 1.125;
        text-align: ${variant === 'text' ? 'center' : 'left'};
        ${variant === 'text' && `width: calc(100% - 32px)`};
      }

      .option-subtitle {
        color: ${colors.textMuted};
        font-size: 14px;
      }

      .option-details-title {
        color: ${colors.black};
        font-size: 20px;
        font-weight: bold;
      }

      .option-details-content {
        margin-top: 10px;
      }

      .option-details-subtitle {
        color: ${colors.brown};
        font-size: 15px;
        font-weight: bold;
        line-height: 1.25;
      }

      .option :global(p) {
        color: ${colors.brown};
        font-size: 15px;
        margin: 0;
      }
    `}</style>
  </div>
);

export default Option;
